import VueRouter, { RouteConfig } from "vue-router";
import { authStore } from "@/store/typed";
import User from "@/models/User";
import AuthenticationRoutes from "@/router/Authentication";
import ScoutingRoutes from "@/router/Scouting";
import SecuredRoutes from "@/router/Secured";
import CompaniesRoutes from "@/router/Companies";
import ToolsRoutes from "@/router/Tools";
import SettingsRoutes from "@/router/Settings";

import { isMetaProperty } from "typescript";

// TODO: sostituire tutti i role: ['admin', 'superadmin'] con User.adminRoles.map(o => o.id)

const routes: RouteConfig[] = [
  {
    path: "/",
    redirect: "/secure",
    name: "root",
    meta: { role: ["anyone"] },
  },
  {
    path: "/secure",
    name: "secure",
    component: () => import("@/views/Container.vue"),
    meta: { role: ["anyone"] },
    children: [...ScoutingRoutes, ...CompaniesRoutes, ...ToolsRoutes],
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/views/Container.vue"),
    meta: { role: ["administrator", "system_administrator", "superadmin"] },
    children: [...SettingsRoutes],
  },
  //Password retrieval
  {
    path: "/forgot_password",
    component: () => import("@/views/Password/Forgot.vue"),
    name: "forgot_password",
    meta: { noAuth: true },
  },
  {
    path: "/reset_password",
    component: () => import("@/views/Password/Reset.vue"),
    name: "reset_password",
    meta: { noAuth: true },
  },
  {
    path: "/styleguide",
    component: () => import("@/views/Styleguide.vue"),
    name: "styleguide",
    meta: { noAuth: true },
  },

  ...AuthenticationRoutes,
  {
    path: "*",
    component: () => import("@/views/NotFound.vue"),
    name: "404",
    meta: { role: ["anyone"] },
  },
];

const router = new VueRouter({
  base: "/",
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  const { role, noAuth } = to?.matched[0]?.meta || {};

  authStore.authenticate().then(
    (user: User | undefined) => {
      if (to?.matched?.some((record) => record.meta.noAuth)) {
        next("/");
        return;
      }
      if (role && !role.includes("anyone")) {
        if (!role.includes(user?.role)) {
          next("/");
          return;
        }
      }
      const matched = to?.matched?.reduce((acc, route) => {
        return acc && route.name === "secure";
      }, true);
      if (matched) {
        next({ name: "scouting" });
      }
      if (role?.includes(user?.role) || role?.includes("anyone")) {
        // if authorized
        next();
        return;
      } else {
        // if not it is redirected
        next(false);
        return;
      }
    },
    () => {
      if (to?.matched?.every((record) => record.meta.noAuth)) {
        next();
        return;
      } else {
        next({ name: "login" });
      }
    },
  );
});

export default router;
